import { useQuery } from '@tanstack/react-query';
import { reportService } from '@services/reportService';

export const useBalanceEvolution = (months = 6) => {
  return useQuery({
    queryKey: ['reports', 'balance-evolution', months],
    queryFn: () => reportService.getBalanceEvolution(months),
  });
};

export const useCategoryReport = (startDate, endDate) => {
  return useQuery({
    queryKey: ['reports', 'categories', startDate, endDate],
    queryFn: () => reportService.getCategoryReport(startDate, endDate),
    enabled: !!startDate && !!endDate,
  });
};

export const useMonthlyComparison = (months = 6) => {
  return useQuery({
    queryKey: ['reports', 'monthly-comparison', months],
    queryFn: () => reportService.getMonthlyComparison(months),
  });
};

export const useCashFlowProjection = (months = 6) => {
  return useQuery({
    queryKey: ['reports', 'cash-flow', months],
    queryFn: () => reportService.getCashFlowProjection(months),
  });
};

export const useSummaryReport = () => {
  return useQuery({
    queryKey: ['reports', 'summary'],
    queryFn: reportService.getSummaryReport,
  });
};

export const useReports = () => {
  return {
    useBalanceEvolution,
    useCategoryReport,
    useMonthlyComparison,
    useCashFlowProjection,
    useSummaryReport,
  };
};

export default useReports;
